import React from 'react'
import PropTypes from 'prop-types'
import isEmpty from 'lodash/isEmpty'
import PrivacyMessageCheckboxArea from './PrivacyMessageCheckboxArea'

import './style.css.scss'

const PrivacyMessage = ({config, setSendButtonDisabled}) => {

  const hasCheckBoxes = !isEmpty(config.checkbox_area.checkboxes)
  if (!hasCheckBoxes) {
    setSendButtonDisabled(false)
  }

  return config.message && (
    // dangerouslySetInnerHTML is React’s replacement for using innerHTML in the browser DOM.
    // reference: https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml
    <div className="privacy-message-container">
      <div dangerouslySetInnerHTML={{__html: config.message.html}}></div>
      {
        hasCheckBoxes &&
          <PrivacyMessageCheckboxArea
            config={config.checkbox_area}
            setSendButtonDisabled={setSendButtonDisabled} />
      }
      {
        !!config.text_area &&
          <div
            className='text-area'
            dangerouslySetInnerHTML={{__html: config.text_area.html}}>
          </div>
      }
      </div>
  )
}

PrivacyMessage.propTypes = {
  config: PropTypes.object.isRequired,
  setSendButtonDisabled: PropTypes.func.isRequired
}

export default PrivacyMessage
